import http, { getStateless, makeHttp } from "@/http";
import type { ResponsePetBattleOptions } from "@/cuties/model/pet/ResponsePetBattleOptions";
import type AdventureModel from "@/cuties/model/adventure/AdventureModel";
import IntroductionSystem from "@/cuties/player/introduction/IntroductionSystem";
import type AdventurePreviewModel from "@/cuties/model/adventure/AdventurePreviewModel";
const unversionedHttp = makeHttp({ baseUrl: "/rest" });

/** mapping to some of the routes in AdventureController.java */
export default class AdventureService {
    public static async getAdventreMapConfig(): Promise<AdventureMap> {
        return http.get("/static/maps/adventures/map.json", { baseURL: "" }).then((response) => {
            return response.data;
        });
    }

    public static async getAdventureDefinition(params: { name: string }): Promise<AdventureModel> {
        return http.get("/public/adventure/definition", { params, baseURL: "/rest" }).then(rs => rs.data);
    }

    public static async sendToAdventure(request: AdventureStartRequest): Promise<StartAdventureResponse> {
        return http.post("/adventure_start", request).then((response) => {
            IntroductionSystem.completeStep("SEND_CUTIE_TO_ADVENTURE");
            return response.data;
        });
    }

    public static async getAdventureListGroup(groupId: number): Promise<ResponsePetBattleOptions> {
        return this.requestPostData("/pet/group/battle/options", { groupId: groupId });
    }

    public static async getAdventureListSelection(petIds: number[]): Promise<ResponsePetBattleOptions> {
        return this.requestPostData("/pet/selection/battle/options", { pets: petIds });
    }

    public static async getAdventureListAll(): Promise<ResponsePetBattleOptions> {
        return this.requestPostData("/pet/mass/battle/options", {});
    }

    public static async getAdventureListSingle(petId: number): Promise<ResponsePetBattleOptions> {
        return this.requestPostData("/pet/single/battle/options", { pets: [petId] });
    }

    public static async getMatchmakingStats(): Promise<AdventureMatchmakingStat[]> {
        return getStateless("/public/adventures/matchmaking/stats").then(rs => rs.data);
    }

    public static async getAdventureListShallow(): Promise<{ adventures: AdventurePreviewModel[] }> {
        return http.get("/adventures").then(rs => rs.data);
    }

    public static async sendToAdventures(url: string, data: any): Promise<ResponsePetBattleOptions> {
        return this.requestPostData(url, data);
    }

    private static async requestPostData(url: string, data: any): Promise<any> {
        return http.post(url, data).then((response) => response.data);
    }

    private static async requestGetData(url: string): Promise<ResponsePetBattleOptions> {
        return http.get(url).then((response) => response.data);
    }
}

export interface AdventureMap {
    id: string;
    POI: PointOfInterest[];
}

export interface PointOfInterest {
    id: string;
    active: boolean;
    type: "adventure" | "raidboss" | "link";
    link?: string;
    adventure: string;
    x: number;
    y: number;
}

export interface AdventureStartRequest {
    petId: number;
    adventureConfigId: string;
}

type MatchResult = "WON" | "LOST" | "SCHEDULED";

/** @see StartAdventureResponse.java */
export interface StartAdventureResponse {
    matchResult: MatchResult;
}

interface AdventureMatchmakingStat {
    location: string;
    pendingCutiesCount: number;
}
